export const specialCharacter = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];

export const patterns: { [key: string]: number } = {
  "[A-Z]": 4, // Uppercase letters
  "[a-z]": 4, // Lowercase letters
  "[0-9]": 2, // Numbers
  "[^A-Za-z0-9]": 6, // Special characters
  "(.)\\1{1,}": -10, // Repeating characters
  "^[a-z]+$": -10, // All characters are lowercase
  "^[A-Z]+$": -10, // All characters are uppercase
  "^[0-9]+$": -10, // All characters are numbers
};

export const commonPatterns = [
  "123",
  "abc",
  "qwe",
  "asd",
  "zxc",
  "password",
  "qwerty",
  "admin",
  "letmein",
  "welcome",
  "monkey",
  "dragon",
  "football",
  "iloveyou",
  "123456",
  "111111",
  "123456789",
  "password1",
  "12345678",
  "sunshine",
  "123123",
  "princess",
  "login",
  "welcome1",
  "solo",
  "shadow",
  "master",
  "starwars",
  "hello",
  "superman",
  "hockey",
  "george",
  "flower",
  "fuckyou",
  "baseball",
  "summer",
  "qazwsx",
  "jennifer",
  "whatever",
  "jessica",
  "monkey1",
  "asdfgh",
  "trustno1",
  "charlie",
  "michael",
  "iloveyou1",
  "buster",
  "jordan",
  "killer",
  "freedom",
  "chester",
  "thomas",
  "tigger",
  "access",
  "matrix",
  "william",
  "hello1",
  "iloveyou2",
  "purple",
  "banana",
  "abcd1234",
  "cookie",
  "killer1",
  "dragon1",
  "chelsea",
  "samantha",
  "kenneth",
  "dallas",
  "horses",
  "qwertyuiop",
  "passw0rd",
  "trustme",
  "fishing",
  "baseball1",
  "jesus",
  "jessie",
  "hello123",
  "joshua",
  "cheese",
  "biteme",
  "marilyn",
  "sexy",
  "thunder",
  "blink182",
  "angel",
  "little",
  "monkey123",
  "pokemon",
  "pokemon1",
  "pikachu",
  "password123",
  "abcdef",
  "daniel",
  "liverpool",
  "jackson",
  "scooter",
  "dolphin",
  "samanth",
  "samsung",
  "arsenal",
  "ginger",
  "fluffy",
  "harry",
  "welcome123",
  "maggie",
  "harley",
  "aaaaaa",
  "abc123",
  "abcd",
  "julian",
  "taylor",
  "ferrari",
  "butterfly",
  "sexy1",
  "purple1",
  "jordan23",
  "bigdog",
  "chicken",
  "softball",
  "killer2",
  "scooby",
  "scoobydoo",
  "badboy",
  "computer",
  "trust",
  "jupiter",
  "mustang",
  "andrew",
  "boomer",
  "thx1138",
  "zzzzzz",
  "midnight",
  "ranger",
  "bigdick",
  "asdf",
  "james",
  "bigdaddy",
  "internet",
  "warrior",
  "cowboy",
  "orange",
  "iloveu",
  "trustme1",
  "redsox",
  "super",
  "babygirl",
  "matrix1",
  "corvette",
  "peanut",
  "jaguar",
  "diamond",
  "babydoll",
  "amanda",
  "freddy",
  "lakers",
  "yankees",
  "maxwell",
  "magnum",
  "member",
  "badass",
  "forever",
  "pumpkin",
  "qwerty123",
  "dickhead",
  "lucky",
  "charles",
  "stupid",
  "monica",
  "genius",
  "marine",
  "tiffany",
  "willie",
  "zzzz",
  "therock",
  "coffee",
  "gregory",
  "michelle",
  "david",
  "football1",
  "passion",
  "flower1",
  "aquarius",
  "hotdog",
  "freedom1",
  "matrix123",
  "marlboro",
  "mememe",
  "killer3",
  "sandra",
  "froggy",
  "snickers",
  "qwertyui",
  "asdfghjkl",
  "bigtits",
  "bond007",
  "douglas",
  "drummer",
  "harvey",
  "hannah",
  "hendrix",
  "herman",
  "diamond1",
  "jenny",
  "tristan",
  "winner",
  "julie",
  "justin",
  "madison",
  "candy",
  "safety",
  "golf",
  "dick",
  "badass1",
  "romeo",
  "samson",
  "steve",
  "rachel",
  "tara",
  "asdfasdf",
  "helloworld",
  "maggie1",
  "harold",
  "dreams",
  "sucker",
  "chocolat",
  "claire",
  "falcon",
  "flower2",
  "frankie",
  "gandalf",
  "hotrod",
  "redskins",
  "spider",
  "joe",
  "love",
  "marina",
  "nirvana",
  "sailor",
  "samuel",
  "scorpion",
  "startrek",
  "stargate",
  "sunflower",
  "yamaha",
  "cherry",
  "helen",
  "justme",
  "kristina",
  "pamela",
  "robert",
  "admin123",
  "anthony",
  "apollo",
  "athena",
  "blazer",
  "brandon",
  "cosmos",
  "cowboys",
  "daisy",
  "danny",
  "darkness",
  "faith",
  "genesis",
  "gizmo",
  "happy",
  "john",
  "kelly",
  "killer4",
  "marcus",
  "martin",
  "mercedes",
  "mickey",
  "miller",
  "music",
  "naughty",
  "paul",
  "pepper",
  "prince",
  "rocket",
  "roger",
  "rose",
  "shannon",
  "silver",
  "smokey",
  "snake",
  "speedy",
  "spencer",
  "theman",
  "warriors",
  "wendy",
  "winter",
  "wireless",
  "wolf",
  "xavier",
  "zxcvbnm",
  "555555",
  "aaa",
  "abc123",
  "abcdef",
  "access",
  "access14",
  "action",
  "albert",
  "alexis",
  "alice",
  "alpha",
  "amateur",
  "andrea",
  "andrew",
  "angela",
  "angels",
  "animal",
  "annette",
  "anthony1",
  "apples",
  "arsenal",
  "art",
  "asdf",
  "ashley",
  "august",
  "austin",
  "avalon",
  "badboy",
  "bailey",
  "banana",
  "barney",
  "batman",
  "bbb",
  "beach",
  "beavis",
  "beer",
  "benjamin",
  "bigdog",
  "bigred",
  "birdie",
  "bitches",
  "biteme",
  "blonde",
  "blondes",
  "bluesky",
  "booboo",
  "boomer",
  "boston",
  "brandy",
  "braves",
  "brenda",
  "bronco",
  "broncos",
  "brooke",
  "brownie",
  "bruce",
  "bruno",
  "buddy1",
  "buffalo",
  "bugger",
  "bull",
  "bulldog",
  "bullet",
  "burton",
  "butterfly",
  "butterfly1",
  "butthead",
  "buzzard",
  "calvin",
  "camaro",
  "cameron",
  "captain",
  "carla",
  "carlos",
  "caroline",
  "carrie",
  "cartman",
  "casper",
  "cassandra",
  "castro",
  "catherine",
  "cavalier",
  "champ",
  "charlie1",
  "cheese",
  "cherokee",
  "chicago",
  "chico",
  "chris",
  "christin",
  "christopher",
  "church",
  "cindy",
  "cobra",
  "cocacola",
  "coffee1",
  "colleen",
  "colorado",
  "comanche",
  "compaq",
  "computer",
  "cookie",
  "cool",
  "cooper",
  "cowboy",
  "coyote",
  "cricket",
  "cruise",
  "crystal",
  "cynthia",
  "dakota",
  "dallas",
  "daniel1",
  "danny1",
  "dave",
  "david1",
  "debbie",
  "deborah",
  "deepthroat",
  "defender",
  "delta",
  "dennis",
  "desire",
  "destiny",
  "diablo",
  "diana",
  "diesel",
  "digger",
  "doggy",
  "doggy1",
  "dollar",
  "dolphin",
  "dominic",
  "donald",
  "dookie",
  "dragon1",
  "dusty",
  "eagle",
  "edward",
  "elephant",
  "elvis",
  "emily",
  "energy",
  "enigma",
  "enterprise",
  "eric",
  "esther",
  "eugene",
  "evelyn",
  "excalibu",
  "falcon1",
  "fantasy",
  "fender",
];
